import React, { Component } from  'react'
import { PropTypes } from 'prop-types'
import Collapsible from 'react-collapsible';
import { Link } from 'react-router'
import { BurgerMenu } from '..'
import bem from '../../../common/bem'
import './Sidebar.scss'

export default class Sidebar extends Component {

  static defaultProps = {
    isOpen: false,
    currentPath: null,
  }

  static propTypes = {
    routeStruct: PropTypes.object,
    headerRouteStruct: PropTypes.object,
    headerChildren:PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    footerChildren:PropTypes.oneOfType([PropTypes.element, PropTypes.string])
  }

  componentWillMount() {
    this.collapsible = []
  }

  componentWillUpdate() {
    this.collapsible = []
  }

  _genRanKey(type, title) {
    return `${type}_${title}_${Math.round( Math.random() * 1000 )}`
  }

  _navNormal({bemmer, url, title='Name', currentPath}) {
    const childUrl = url
    const currentPage = childUrl ===  currentPath
    const newBemmer = currentPage ? bemmer.element('no-collapse-link').modifier('current-page') : bemmer.element('no-collapse-link')
    return (
      <Link
        key={this._genRanKey('sidebar_normal', title)}
        className={newBemmer}
        to={childUrl}>
        {title}
      </Link>
    )
  }

  _navCollapsable({bemmer, id, title='Name', children=[], currentPath}) {
    const colBemmer = bemmer.element('collapsible')
    const outerBemmer = bemmer.element('collapsible-outer')
    const innerBemmer = bemmer.element('collapsible-inner')
    let stayOpen = false

    // SORT IT
    const keys = Object.keys(children).sort((a, b) => children[a].sort > children[b].sort)

    const innerContent = keys.map(index => {
      const linkBemmer = bemmer.element('collapsible-inner-link')
      let childUrl = children[index].url
      const currentPage = childUrl ===  currentPath
      if(currentPage) stayOpen = true
      return (

        <Link
          className={linkBemmer.modifier(currentPage ? 'current-page' : null)}
          key={this._genRanKey('sidebar_link', children[index].title)}
          to={childUrl}>
          {children[index].title}
          {children[index].tags && children[index].tags.indexOf('new') >= 0 ?
            <span
              className = {bemmer.element('badge')}>
                <img
                  className={bemmer.element('badge__image')}
                  src='/images/tag-new-content.png' />
            </span> : ''
            }
        </Link>
      )
    })

    return(
      <Collapsible
        ref={component => this.collapsible.push(component)}
        open={stayOpen}
        key={this._genRanKey('sidebar_collapse', title)}
        className={colBemmer.toString()}
        openedClassName={colBemmer.modifier('opened').toString()}
        triggerClassName={outerBemmer.toString()}
        triggerOpenedClassName={outerBemmer.modifier('opened').toString()}
        contentInnerClassName={innerBemmer.toString()}
        transitionTime={200}
        trigger={<span>{title}<i className="arrow-icon" /></span>} >
        { innerContent }
      </Collapsible>
    )
  }

  renderInnerNavs({bemmer, routeStruct, currentPath}) {
    const keys = Object.keys(routeStruct).sort((a, b) => routeStruct[a].sort > routeStruct[b].sort)

    return keys.map(index => {
      if (routeStruct[index].children) return this._navCollapsable({bemmer, ...routeStruct[index], currentPath})
      return this._navNormal({bemmer, ...routeStruct[index], currentPath})
    })
  }

  render() {
    const bemmer = bem('sidebar');
    const { isOpen, headerChildren, footerChildren, routeStruct,
      currentPath, curMenuState, onMenuChange, className} = this.props;

    return (
      <nav className={`${bemmer.element('container').modifier(isOpen ? 'active' : 'inactive')} ${className}`}>
        <header className={bemmer.element('header')}>
          <Link to='/'>
            <h1 className='sls-zone-hero'>SLS Zone</h1>
          </Link>
          <BurgerMenu curMenuState={curMenuState} onMenuChange={onMenuChange} />
          {headerChildren}
        </header>

        { !routeStruct ? <div /> : this.renderInnerNavs({bemmer, routeStruct, currentPath})}
        <footer>
          { footerChildren }
        </footer>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./component/ui/Sidebar/Sidebar.js